import React from 'react';
import { FaLinkedin } from 'react-icons/fa';
import './LinkedIn_Feed.css';

/*
 * LinkedIn posts.
 *
 * To add one: open the post on LinkedIn, click the "..." menu, choose
 * "Embed this post", and paste either the post URL or the urn:li:... id below.
 * Anything of these forms works:
 *
 *   'https://www.linkedin.com/posts/zach-robers_slug-activity-7123456789012345678-AbCd'
 *   'urn:li:activity:7123456789012345678'
 *   'urn:li:share:7123456789012345678'
 *   '7123456789012345678'
 *
 * `height` is optional and defaults to 600. LinkedIn embeds cannot resize
 * themselves from another origin, so a long text post needs a taller value;
 * anything that overflows scrolls inside its own card.
 */
const posts = [
  {
    url: 'urn:li:share:7228731079082283008',
    title: 'Studying the philosophy and ethics of AI at Oxford',
    height: 1509,
  },
  // Paste the remaining posts here, newest first. For example:
  // { url: '<ConnectU launch post URL>', height: 700 },
  // { url: '<Hickey Lab repost URL>', height: 700 },
  // { url: '<APS Division of Fluid Dynamics post URL>', height: 700 },
  // { url: '<SAILea repost URL>', height: 700 },
];

const EMBED_BASE = 'https://www.linkedin.com/embed/feed/update/';

export const toEmbedUrl = (value) => {
  if (typeof value !== 'string') return null;
  const post = value.trim();

  if (post.startsWith('urn:li:')) return EMBED_BASE + post;

  // A normal post URL ends in ...-activity-<id>-<hash>
  const activity = post.match(/activity[-:](\d{10,})/);
  if (activity) return `${EMBED_BASE}urn:li:activity:${activity[1]}`;

  const share = post.match(/share[-:](\d{10,})/);
  if (share) return `${EMBED_BASE}urn:li:share:${share[1]}`;

  const ugc = post.match(/ugcPost[-:](\d{10,})/);
  if (ugc) return `${EMBED_BASE}urn:li:ugcPost:${ugc[1]}`;

  if (/^\d{10,}$/.test(post)) return `${EMBED_BASE}urn:li:activity:${post}`;

  return null;
};

const PROFILE_URL = 'https://www.linkedin.com/in/zach-robers-0579b7236/';

const LinkedInFeed = () => {
  const embeds = posts
    .map((post) => ({ ...post, src: toEmbedUrl(post.url) }))
    .filter((post) => post.src);

  if (!embeds.length) return null;

  return (
    <section className="li-feed" aria-label="Recent LinkedIn posts">
      <div className="li-feed-head">
        <h2>
          <FaLinkedin aria-hidden="true" /> Recent on LinkedIn
        </h2>
        <a
          href={PROFILE_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="li-feed-link"
        >
          See the full feed <span aria-hidden="true">&rarr;</span>
        </a>
      </div>

      <div className="li-feed-grid">
        {embeds.map((post) => (
          <div className="li-post" key={post.src}>
            <iframe
              src={post.src}
              height={post.height || 600}
              width="100%"
              frameBorder="0"
              allowFullScreen
              title={post.title || 'LinkedIn post'}
              loading="lazy"
            />
          </div>
        ))}
      </div>
    </section>
  );
};

export default LinkedInFeed;
